import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Breadcrumb = ({ items }) => {
  return (
    <nav style={{display:"block",marginTop:"15px"}} className="flex items-center space-x-2 text-sm text-gray-600 bg-gray-50 p-3 ml-[20px] mr-[20px] rounded-lg border border-gray-200">
      <span>
       <Link to = '/'>
            Home
       </Link>
        </span>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight className="text-gray-400" />
          {item.onClick ? (
            <button
              onClick={item.onClick}
              className="hover:text-blue-600 transition-colors duration-200 font-medium"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-gray-900 font-medium">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};